import { ClipboardModule } from 'ngx-clipboard';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng-lts/calendar';
import { CheckboxModule } from 'primeng-lts/checkbox';
import { DropdownModule } from 'primeng-lts/dropdown';
import { MultiSelectModule } from 'primeng-lts/multiselect';
import { SelectButtonModule } from 'primeng-lts/selectbutton';
import { TooltipModule } from 'primeng-lts/tooltip';
import { DesignPatternComponentsModule } from '@al/design-patterns';
import { NgFormsComponentsModule } from '@al/ng-forms-components';
import { NgGenericComponentsModule } from '@al/ng-generic-components';
import { NgVisualizationModule } from '@al/ng-visualizations-components';
import * as manifest from './manifest';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        NgGenericComponentsModule,
        MultiSelectModule,
        NgFormsComponentsModule,
        NgVisualizationModule,
        DesignPatternComponentsModule,
        CalendarModule,
        TooltipModule,
        CheckboxModule,
        ClipboardModule,
        DropdownModule,
        SelectButtonModule,
    ],
    declarations: [
        ...manifest.MODULE_COMPONENTS,
        ...manifest.MODULE_DIRECTIVES,
        ...manifest.MODULE_PIPES,
    ],
    exports: [
        ...manifest.MODULE_COMPONENTS,
        ...manifest.MODULE_DIRECTIVES,
        ...manifest.MODULE_PIPES,
    ],
    providers: [
        ...manifest.MODULE_SERVICES,
    ]
})
export class NgContentComponentsModule {
}
